import { Formheader, GrayBox } from "@/Components";
import { LabeledInput } from "@/Components/Form";
import React, { useEffect } from "react";
import { usePayload } from "@/Contexts/PayloadContext";
import { usePage } from "@inertiajs/inertia-react";

export default function SuperUserFormPart({ user = null }) {
  const { payload, setPayload, onFormChange } = usePayload();

  const errors = usePage().props?.errors || {};

  useEffect(() => {
    if (user) {
      setPayload(user);
    }
  }, []);

  return (
    <>
      <GrayBox margin="mb-4">
        <div className="flex flex-wrap gap-4">
          <Formheader margin="w-full">User details</Formheader>
          <LabeledInput
            required
            title="First name"
            name="firstname"
            onChange={onFormChange}
            containerClass="w-full sm:basis-1/2-gap-4"
            placeholder="Enter first name"
            value={payload?.firstname || ""}
            error={errors?.firstname}
          />
          <LabeledInput
            required
            title="Surname"
            name="surname"
            onChange={onFormChange}
            containerClass="w-full sm:basis-1/2-gap-4"
            placeholder="Enter surname"
            value={payload?.surname || ""}
            error={errors?.surname}
          />
          <LabeledInput
            required
            title="E-mail"
            name="email"
            onChange={onFormChange}
            containerClass="w-full"
            placeholder="Enter e-mail"
            type="email"
            value={payload?.email || ""}
            error={errors?.email}
          />
          <LabeledInput
            required
            title="Phone number"
            name="phone"
            onChange={onFormChange}
            containerClass="w-full"
            placeholder="Enter phone number"
            value={payload?.phone || ""}
            error={errors?.phone}
          />
        </div>
      </GrayBox>
    </>
  );
}
